import './logic_and_or.scss';
import React, { useEffect, useState } from 'react';
import { useDblIntl } from '@/pages/datalab/utils/utils';

export function LogicAndOr(props: {
  value: number | undefined;
  columnCount: number;
  onChange: (value: number) => void;
}) {
  const { value, columnCount, onChange } = props;
  const { dblFormatMessage: explorationFormatMessage } =
    useDblIntl('exploration');
  const [logicValue, setLogicValue] = useState(value || 0);
  useEffect(() => {
    onChange(logicValue);
  }, [logicValue]);
  return (
    <div className="context-left">
      <div className="context-left-box">
        {columnCount > 1 ? (
          <div className="context-left-bg">
            <div
              className={logicValue === 0 ? 'context-left-top' : 'tab-action'}
              onClick={() => {
                setLogicValue(0);
              }}
            >
              {explorationFormatMessage('and')}
            </div>
            <div
              className={
                logicValue === 0 ? 'tab-action' : 'context-left-bottom'
              }
              onClick={() => {
                setLogicValue(1);
              }}
            >
              {explorationFormatMessage('or')}
            </div>
          </div>
        ) : (
          ''
        )}
      </div>
    </div>
  );
}
